import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonProgressBar,
  IonRouterOutlet,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import React, { useState } from "react";
import { Redirect, Route, useHistory, useLocation } from "react-router-dom";

// Import all components for each step
import GolfIcon from "@/components/GolfIcon";
import AvatarSetup from "@/components/welcome/AvatarSetup";
import GenderSelection from "@/components/welcome/GenderSelection";
import GolfProfileSetup from "@/components/welcome/GolfProfileSetup";
import HandicapSelection from "@/components/welcome/HandicapSelection";
import MembershipSelection from "@/components/welcome/MembershipSelection";
import RoleSelection from "@/components/welcome/RoleSelection";
import UsernameSelection from "@/components/welcome/Username";
import { signOut } from "@/utils/capacitorUtils";

const Welcome: React.FC = () => {
  document.title = "CapGolf - Onboarding";
  const [isLoading, setIsLoading] = useState(false);
  const [showHeader, setShowHeader] = useState(true);

  const steps = [
    { path: "/welcome/role", component: RoleSelection, skip: false },
    { path: "/welcome/gender", component: GenderSelection, skip: true },
    { path: "/welcome/profile-details", component: GolfProfileSetup, skip: false },
    { path: "/welcome/golf-profile", component: GolfProfileSetup, skip: false },
    { path: "/welcome/handicap", component: HandicapSelection, skip: true },
    { path: "/welcome/avatar", component: AvatarSetup, skip: true },
    { path: "/welcome/membership", component: MembershipSelection, skip: true },
    { path: "/welcome/username", component: UsernameSelection, skip: false },
  ];

  const location = useLocation();
  const history = useHistory();

  if (location.pathname === '/welcome') {
    return <Redirect to={steps[0].path} />;
  }

  // Progression steps calculation
  const currentStepIndex = steps.findIndex((step) => step.path === location.pathname);
  const currentStep = currentStepIndex >= 0 ? currentStepIndex + 1 : 1; // Index starts from 0, so add 1 for display

  // Callback function for components to control loading state and header visibility
  const setLoadingState = (loading: boolean, hideHeader: boolean = loading) => {
    setIsLoading(loading);
    setShowHeader(!hideHeader);
  };

  return (
    <IonPage>
      {showHeader && (
        <IonHeader className="ion-no-border bg-card">
          <IonToolbar>
            <IonButtons slot="start">
              {!location.pathname.includes(steps[0].path) && !isLoading && (
                <IonBackButton
                  className="text-foreground"
                  text=""
                  defaultHref={steps[currentStep - 1].path}
                  disabled={isLoading}
                />
              )}
            </IonButtons>
            <IonButtons slot="end">
              {!isLoading && false && (
                <IonButton
                  onClick={async (event) => {
                    event.preventDefault()
                    await signOut();
                    history.push('/')
                  }}
                  disabled={isLoading}
                >
                  <GolfIcon name="close" className="size-5" />
                </IonButton>
              )}
            </IonButtons>
            <IonTitle><IonProgressBar className="h-3" value={(currentStep - 1) / (steps.length - 1)}></IonProgressBar></IonTitle>
          </IonToolbar>
        </IonHeader>
      )}

      <IonContent fullscreen>
        <IonRouterOutlet>
          <Route exact path="/welcome/role">
            <RoleSelection nextStep="/welcome/gender" setLoadingState={setLoadingState} />
          </Route>
          <Route exact path="/welcome/gender">
            <GenderSelection nextStep="/welcome/profile-details" setLoadingState={setLoadingState} />
          </Route>
          <Route exact path="/welcome/profile-details">
            <GolfProfileSetup nextStep="/welcome/golf-profile" setLoadingState={setLoadingState} />
          </Route>
          <Route exact path="/welcome/golf-profile">
            <GolfProfileSetup nextStep="/welcome/username" setLoadingState={setLoadingState} />
          </Route>
          <Route exact path="/welcome/username">
            <UsernameSelection nextStep="/dashboard" setLoadingState={setLoadingState} />
          </Route>
          <Route exact path="/welcome">
            <Redirect to="/welcome/role" />
          </Route>
        </IonRouterOutlet>
      </IonContent>
    </IonPage >
  );
};

export default Welcome;